import {SUBCATEGORY_MAP, SubcategoryDefinition} from '../constants/categoryMapping';
import {SubcategoryId} from '../schemas';

const DEFAULT_SUBCATEGORY: SubcategoryDefinition = {
  id: 'engine-mechanical',
  title: 'Engine Mechanical & Timing',
  mainGroupId: 'engine-parts',
};

export function getSubcategory(id: SubcategoryId): SubcategoryDefinition {
  return SUBCATEGORY_MAP.get(id) ?? DEFAULT_SUBCATEGORY;
}
